
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"19.998","height":"19.998"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"id":"checkmark","transform":"translate(-1716.5 -102.001)"}},[_c('path',{attrs:{"id":"Ellipse_98","data-name":"Ellipse 98","d":"M1726.5 102.501a9.5 9.5 0 11-9.5 9.5 9.5 9.5 0 019.5-9.5z","fill":"#fff","stroke":"#dfe4ef","stroke-width":"1"}}),_c('g',{staticStyle:{"mix-blend-mode":"normal","isolation":"isolate"},attrs:{"id":"_","transform":"translate(1723.174 106.684)"}},[_c('g',{staticStyle:{"mix-blend-mode":"normal","isolation":"isolate"},attrs:{"id":"Group_6698","data-name":"Group 6698"}},[_c('path',{attrs:{"id":"Path_921","data-name":"Path 921","d":"M278.116 321.761a4.29 4.29 0 01.243-1.6 3.282 3.282 0 01.889-1.169 4.567 4.567 0 00.861-.937 1.474 1.474 0 00.215-.763q0-1.21-1.115-1.21a1.133 1.133 0 00-.847.325 1.283 1.283 0 00-.333.9h-2.072a2.754 2.754 0 01.882-2.139 4.077 4.077 0 014.72-.04 2.608 2.608 0 01.836 2.072 2.513 2.513 0 01-.272 1.147 4.713 4.713 0 01-.95 1.2l-.579.55a1.959 1.959 0 00-.622 1.223l-.028.437zm-.207 2.19a1.039 1.039 0 01.325-.787 1.274 1.274 0 011.665 0 1.11 1.11 0 01.007 1.563 1.3 1.3 0 01-1.679 0 1.032 1.032 0 01-.319-.776z","transform":"translate(-275.958 -314.401)","fill":"#6b7786"}})])])])])
          )
        }
      }
    